import React, { FC, useState } from "react";
import editIcon from "assets/icons/edit.svg";

interface ReviewDetailsProps {
  id: "policyHolder" | "insuredDetails" | "nomineeDetails";
  formProps: any;
}

export const reviewConstants: any = {
  policyHolder: [
    {
      title: "Policy Holder Name",
      key: "policyHolderName",
      label: "Please enter the correct name"
    },
    {
      title: "Policy Holder Mobile",
      key: "phone",
      label: "Please enter the correct policy holder mobile"
    },
    {
      title: "Policy Holder Email",
      key: "email",
      label: "Please enter the correct email"
    },
    {
      title: "Residential Address",
      key: "address",
      label: "Please enter the correct residential address"
    }
  ],
  insuredDetails: [
    {
      title: "Insured Name",
      key: "name"
    },
    {
      title: "Date of Birth",
      key: "dob"
    },
    {
      title: "Gender",
      key: "gender"
    },
    {
      title: "Relationship with policyholder",
      key: "relation"
    },
    {
      title: "Policy Inception Date",
      key: "policyInceptionDate"
    },
    {
      title: "Pre-existing disease",
      key: "preExistingDiseaseName",
      disclaimer: "Disclosing any pre-existing diseases (PEDs) ensures transparency and helps avoid claim rejections or delays during policy processing."
    }
  ],
  nomineeDetails: [
    {
      title: "Nominee Name",
      key: "nomineeName"
    },
    {
      title: "Nominee Age",
      key: "nomineeAge"
    },
    {
      title: "Relationship",
      key: "nomineeRelation"
    }
  ]
};

const ReviewDetails: FC<ReviewDetailsProps> = ({ id, formProps }) => {
  const [activeEditSection, setActiveEditSection] = useState("");

  const { values, handleChange, initialValues, setFieldValue, setFieldError, errors, policyTypeId, fromHospital } = formProps;

  const manualChangeHandler = (e: any, index: number, fields: any) => {
    const path = `[${id}][${index}].[${fields.key}]`;
    const value = e.target.value;

    setFieldValue(path, value);

    if (value.trim() === "") {
      setFieldError(path, `This field is required`);
    } else {
      setFieldError(path, undefined);
    }
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value = e.target.value;

    if (key === "phone") {
      if (value.trim().length > 11) return;
      else {
        const phoneRegex = /^(0?[6-9]\d{9})$/;
        if (value.trim() === "" || !phoneRegex.test(value)) {
          setFieldError(key, "Invalid phone number");
        } else {
          setFieldError(key, undefined);
        }
      }
    } else if (key === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value.trim() === "" || !emailRegex.test(value)) {
        setFieldError(key, "Invalid email format");
      } else {
        setFieldError(key, undefined);
      }
    } else if (value.trim() === "") setFieldError(key, "This field is required");
    else setFieldError(key, undefined);

    handleChange(e);
  };

  return (
    <div className="px-0 md:px-10">
      <div className={`border-[1px] border-border-color rounded-[6px] ${id === "policyHolder" && "p-5"} text-sm font-bold`}>
        {reviewConstants[id].map((obj: any, index: number) => {
          if (id === "policyHolder") {
            if (!initialValues[obj.key]) return;
            return (
              <div key={index}>
                <div className="flex justify-between items-center pb-5 px-3 md:px-0">
                  <div className="space-y-1 w-full">
                    <div className="flex justify-between w-full mb-1">
                      <p>{obj.title}</p>
                      {policyTypeId && fromHospital ? (
                        ""
                      ) : (
                        <div onClick={() => setActiveEditSection(obj.key)} className="border-[1px]  border-border-color rounded-[5px] flex gap-x-2 shadow-editShadow items-center text-xs font-medium px-3 py-1 cursor-pointer min-w-16">
                          <img src={editIcon} alt="Edit" />
                          <p>Edit</p>
                        </div>
                      )}
                    </div>
                    <p className="font-medium text-sm text-[#000000CC] max-w-[80%]">{initialValues[obj.key]}</p>
                  </div>
                </div>

                <div className={`transition-all duration-300 ease-in-out overflow-hidden ${activeEditSection === obj.key ? "max-h-40 opacity-100" : "max-h-0 opacity-0"} bg-[#F4F5FA80] text-[13px] px-3 md:px-0`}>
                  <div className="py-3 space-y-2">
                    <p>{obj.label}</p>
                    <input name={obj.key} onChange={(e) => onChangeHandler(e, obj.key)} value={values[obj.key]} className="appearance-none border focus:outline-none focus:ring-0 rounded w-full md:w-1/2 py-3 px-2 h-8 text-sm font-semibold bg-white text-gray-700 leading-tight focus:shadow-outline" />
                    {errors[obj.key] && <p className="text-red-500 text-xs mt-1">{errors[obj.key]}</p>}
                  </div>
                </div>
              </div>
            );
          }
        })}

        {id !== "policyHolder" &&
          (values[id] ? (
            values[id]?.map((obj: any, index: number) => {
              return (
                <>
                  {id === "insuredDetails" && <div className="border-[2px] mb-3 bg-[#F4F5FA] px-5 py-2 border-border-color font-extrabold rounded-[6px]">Insured {index + 1}</div>}{" "}
                  <div className={`px-5 ${id === "nomineeDetails" ? "py-6" : "py-2"} `}>
                    {reviewConstants[id].map((fields: any, fieldIndex: number) => {
                      if (!initialValues[id][index][fields.key]) return;
                      return (
                        <div key={fieldIndex}>
                          <div className="flex justify-between items-center pb-5 px-3 md:px-0">
                            <div className="space-y-1">
                              <p>{fields.title}</p>
                              <p className="font-medium text-sm text-[#000000CC] max-w-[80%]">{initialValues[id][index][fields.key]}</p>
                            </div>
                            {policyTypeId && fromHospital ? (
                              ""
                            ) : (
                              <div onClick={() => setActiveEditSection(fields.key + index)} className="border-[1px]  border-border-color rounded-[5px] flex gap-x-2 shadow-editShadow items-center text-xs font-medium px-3 py-1 cursor-pointer">
                                <img src={editIcon} alt="Edit" />
                                <p>Edit</p>
                              </div>
                            )}
                          </div>
                          {fields.disclaimer && <p className="text-[0.7rem] text-gray-500 -mt-3 px-3 md:px-0">{fields.disclaimer}</p>}

                          <div className={`transition-all duration-300 ease-in-out overflow-hidden ${activeEditSection === fields.key + index ? "max-h-40 opacity-100" : "max-h-0 opacity-0"} bg-[#F4F5FA80] text-[13px] px-3 md:px-0`}>
                            <div className="py-3 space-y-2">
                              <p>{fields.label}</p>
                              <input onChange={(e) => manualChangeHandler(e, index, fields)} value={values[id][index][fields.key]} className="appearance-none border focus:outline-none focus:ring-0 rounded w-full md:w-1/2 py-3 pl-2 pr-16 h-8 text-sm font-semibold bg-white text-gray-700 leading-tight focus:shadow-outline" />
                              {errors[id] && errors[id][index] && <p className="text-red-500 text-xs mt-1">{errors[id][index][fields.key]}</p>}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              );
            })
          ) : (
            <p className="text-center py-10 text-xl">No data found</p>
          ))}
      </div>
    </div>
  );
};

export default ReviewDetails;
